/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./ZhResponsibility.css";
import { Link } from "react-router-dom";
import { renderHomePageHeader } from "../../assets/component/renderHomePageHeader.js";
import HomepageMenuZh from "../../assets/component/HomepageMenuZh/HomepageMenuZh.js";

class ZhResponsibility extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  showModal() {
    this.setState({
      showModal: true,
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
    });
  }
  render() {
    return (
      <div className="ZhResponsibility-view">
        {!!this.state.showModal && (
          <HomepageMenuZh closeModal={this.closeModal} />
        )}
        {renderHomePageHeader(this)}

        <div className="ZhResponsibility-first">
          <div className="ZhResponsibility-firstContainer">
            <div className="ZhResponsibility-firstHeading">
              扎根香港，與香港同行
            </div>
            <div className="ZhResponsibility-firstsubHeading">
              CheckPlus 與社會各行各業合作及交流
            </div>
          </div>
        </div>

        <div className="ZhResponsibility-second">
          <div className="ZhResponsibility-content">
            <div className="ZhResponsibility-picture1" />
            <div className="ZhResponsibility-description">
              跟不同慈善機構分享及交流
            </div>
            <div className="ZhResponsibility-picture2" />
            <div className="ZhResponsibility-description">
              獲邀出席不同慈善機構活動
            </div>
            <div className="ZhResponsibility-picture3" />
            <div className="ZhResponsibility-description">
              跟影音使團講解 CheckPlus 平台
              <br />
              賴鈞豪先生 (左) 及 袁文輝先生 (右)
            </div>
            <div className="ZhResponsibility-picture4" />
            <div className="ZhResponsibility-description">
              葉家寶先生 (左) 及 賴鈞豪先生 (右)
            </div>
            <div className="ZhResponsibility-picture5" />
            <div className="ZhResponsibility-description">
              許朝英社長(左)、￼邱騰華 (商務及經濟發展局) 局長 (中) 及 賴鈞豪先生
            </div>
          </div>
        </div>

        <div className="ZhResponsibility-footer">
          <div className="ZhResponsibility-footerNav">
            <Link to="/ZhTeam">
              <div className="ZhResponsibility-footerNavItem">創辦人的故事</div>
            </Link>
            <Link to="/ZhFaq">
              <div className="ZhResponsibility-footerNavItem">常見問題</div>
            </Link>
            <Link to="/ZhContact">
              <div className="ZhResponsibility-footerNavItem">聯絡我們</div>
            </Link>
          </div>

          <div className="ZhResponsibility-footer_text">
            香港九龍油塘四山街 11 號
            <br />
            華利工業大廈 5 樓 A 室
            <br />
            <p />
            Copyright © 2026 CheckPlus Ltd. 保留一切權利。
          </div>
        </div>
      </div>
    );
  }
}

export default ZhResponsibility;
